<div class="panel-group-component" [attr.data-e2e-id]="panelId">
  <div class="panel-heading">
    <div class="panel-title">
      <div>
        <label *ngIf="title" [class.required]="required" [class.single-label]="!description">
          <span>{{ title | translate }}</span>
          <xux-icon *ngIf="iconClass" icon="{{ iconClass }}"></xux-icon>
        </label>
        <div *ngIf="description" class="panel-description-text" [innerHTML]="safeDescription"></div>
      </div>
      <div class="title-tips" *ngIf="titleTips">
        <span class="purple-label">{{ titleTips | translate }}</span>
      </div>
    </div>
    <ng-content select="[panel-heading-content]"></ng-content>
  </div>
  <div class="panel-body">
    <ng-content select="[panel-body-content]"></ng-content>
  </div>
</div>
